<template>
  <div class='animated fadeIn'>
    <b-card no-body>
      <b-card-header class="card-smallHeader">
        <strong>Contacts hors CEV</strong>
        <button type="button" class="btn btn-primary pull-right" @click="openModalAdd">Ajouter</button>
      </b-card-header>
    <b-card-body class="pt-0 pb-0">
      <v-client-table class="mt-3" :columns="columns" :data="items" :options="options">
        <div slot="nom" slot-scope="props">
          {{ props.row.nom }} {{ props.row.prenom }}
        </div>
        <div v-if="props.row.date_neutralisation" slot="date_neutralisation" slot-scope="props">
          {{ formatDate(props.row.date_neutralisation) }}
        </div>
        <div slot="action" slot-scope="props">
          <b-button
            type="button"
            @click.prevent="neutraliser(props.row.id)"
            class="badge badge-danger mr-3 p-2 mb-1"
            :disabled="props.row.date_neutralisation !== null">
            <i class="fa fa-remove"></i> Neutraliser
          </b-button>
          <b-button
            type="button"
            @click="openModalEdit(props.row)"
            class="badge badge-primary p-2">
            <i class="fa fa-edit"></i> Modifier
          </b-button>
        </div>
      </v-client-table>
    </b-card-body>
    </b-card>

    <b-card no-body v-if="cevAdminDoublonItems.length">
      <b-card-header class="card-smallHeader">
        <strong><span class="text-danger">Attention : Admins CEV en doublon pour un même SIRET</span></strong>
      </b-card-header>
      <b-card-body class="pt-0 pb-0">
        <v-client-table class="mt-3" :columns="cevAdminDoublonColumns" :data="cevAdminDoublonItems" :options="cevAdminDoublonOptions">
          <div slot="nom" slot-scope="props">
            {{ props.row.nom }} {{ props.row.prenom }}
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header class="card-smallHeader">
        <strong>Contacts CEV</strong>
      </b-card-header>
    <b-card-body class="pt-0 pb-0">
      <v-client-table class="mt-3" :columns="cevColumns" :data="cevItems" :options="cevOptions">
        <div slot="nom" slot-scope="props">
          {{ props.row.nom }} {{ props.row.prenom }}
        </div>
        <div slot="administrateur" slot-scope="props" v-if="props.row.administrateur === true">
          <span style="color: red;">Administrateur</span>
        </div>
        <div v-else>
          Utilisateur
      </div>
      </v-client-table>
    </b-card-body>
    </b-card>
    <b-modal size="xl" scrollable id="modal-contact" ref="modal-contact" :title="modalTitle">
      <b-card no-body>
        <b-card-body>
          <b-form-group label='Source'
                        label-for='source'>
            <b-form-input id='source'
                          type='text'
                          v-model="source">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Role'
                        label-for='role'>
            <b-form-input id='role'
                          type='text'
                          v-model="role">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Nom'
                        label-for='nom'>
            <b-form-input id='nom'
                          type='text'
                          v-model="nom">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Prenom'
                        label-for='prenom'>
            <b-form-input id='prenom'
                          type='text'
                          v-model="prenom">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Fonction'
                        label-for='fonction'>
            <b-form-input id='fonction'
                          type='text'
                          v-model="fonction">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Email'
                        label-for='email'>
            <b-form-input id='email'
                          type='text'
                          v-model="email">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Téléphone'
                        label-for='telephone'>
            <b-form-input id='telephone'
                          type='text'
                          v-model="telephone">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Adresse'
                        label-for='adresse'>
            <b-form-input id='adresse'
                          type='text'
                          v-model="adresse">
            </b-form-input>
          </b-form-group>
          <b-form-group label='CP'
                        label-for='cp'>
            <b-form-input id='cp'
                          type='text'
                          v-model="cp">
            </b-form-input>
          </b-form-group>
          <b-form-group label='Ville'
                        label-for='ville'>
            <b-form-input id='ville'
                          type='text'
                          v-model="ville">
            </b-form-input>
          </b-form-group>
        </b-card-body>
      </b-card>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal">Annuler</button>
          <button v-if="!isEdit" type="button" @click="saveContact" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
          <button v-if="isEdit" type="button" @click="editContact" class="btn btn-primary"><i class="fa fa-save"></i>
            Modifier
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../../utils/auth";

  export default {
    name: "Contact",
    data() {
      return {
        columns: ["source","role","nom","fonction", "email", 'telephone', 'adresse', 'cp', 'ville', 'date_neutralisation', "action"],
        cevColumns: ["nom","fonction", "email", 'telephone','administrateur'],
        cevAdminDoublonColumns: ["siret","nom", 'email'],
        items: [],
        cevItems: [],
        cevAdminDoublonItems: [],
        options: {
          headings: {
            source: 'Source',
            role: 'Role',
            nom: 'Nom',
            fonction: 'Fonction',
            email: 'Email',
            telephone: 'Téléphone',
            adresse: 'Adresse',
            cp: 'CP',
            ville: 'Ville',
            date_neutralisation: 'Date de neutralisation',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [10, 30, 100],
        },
        cevOptions: {
          headings: {
            nom: 'Nom Prénom',
            fonction: 'Fonction',
            email: 'Email',
            telephone: 'Téléphone',
            administrateur: 'Rôle',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [10, 20, 25],
        },
        cevAdminDoublonOptions: {
          headings: {
            siret : 'SIRET',
            nom: 'Nom Prénom',
            email: 'Email',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [10, 20, 25],
        },
        source: '',
        role: '',
        nom: '',
        prenom: '',
        fonction: '',
        email: '',
        telephone: '',
        adresse: '',
        cp: '',
        ville: '',
        modalTitle: 'Ajouter un nouveau contact',
        isEdit: false,
        contactId: null,
      }
    },
    props: [
      'userCevActive',
      'adminCevDoublon',
    ],
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.siren = this.$route.params.siren;
      this.getContact();
      this.cevItems = this.userCevActive;
      this.cevAdminDoublonItems = this.adminCevDoublon;
    },
    methods: {
      getContact() {
        this.$axios
          .get("/espaceGestion/siren/getContact/"+this.siren)
          .then(response => this.items = response.data.sirenContacts)
          .catch((error) => console.log(error));
      },
      saveContact() {
        const data = {
          source: this.source,
          role: this.role,
          nom: this.nom,
          prenom: this.prenom,
          fonction: this.fonction,
          email: this.email,
          telephone: this.telephone,
          adresse: this.adresse,
          cp: this.cp,
          ville: this.ville,
        };
        this.$axios
          .post("/espaceGestion/siren/addContact/"+this.siren, data)
          .then(response => {
            this.items = response.data.sirenContacts;
            this.closeModal();
          })
          .catch((error) => console.log(error));
      },
      openModalAdd() {
        this.isEdit = false;
        this.modalTitle = 'Ajouter un nouveau contact';
        this.$refs['modal-contact'].show();
      },
      closeModal() {
        this.$refs['modal-contact'].hide();
        this.remiseAZero();
      },
      remiseAZero() {
        this.modalTitle = 'Ajouter un nouveau contact';
        this.source = '';
        this.role = '';
        this.nom = '';
        this.prenom = '';
        this.fonction = '';
        this.email = '';
        this.telephone = '';
        this.adresse = '';
        this.cp = '';
        this.ville = '';
      },
      neutraliser(id){
        this.$axios
          .post(`/espaceGestion/siren/neutraliserContact/${this.siren}/${id}`)
          .then(response => this.items = response.data.sirenContacts)
          .catch((error) => console.log(error));
      },
      openModalEdit(contact){
        this.isEdit = true;
        this.contactId = contact.id;
        this.modalTitle = 'Modifier un nouveau contact';
        this.source = contact.source;
        this.role = contact.role;
        this.nom = contact.nom;
        this.prenom = contact.prenom;
        this.fonction = contact.fonction;
        this.email = contact.email;
        this.telephone = contact.telephone;
        this.adresse = contact.adresse;
        this.cp = contact.cp;
        this.ville = contact.ville;
        this.$refs['modal-contact'].show();
      },
      editContact() {
        const data = {
          id: this.contactId,
          source: this.source,
          role: this.role,
          nom: this.nom,
          prenom: this.prenom,
          fonction: this.fonction,
          email: this.email,
          telephone: this.telephone,
          adresse: this.adresse,
          cp: this.cp,
          ville: this.ville,
        };
        this.$axios
          .post("/espaceGestion/siren/updateContact/"+this.siren, data)
          .then(response => {
            this.items = response.data.sirenContacts;
            this.closeModal();
          })
          .catch((error) => console.log(error));
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      }
    },
  }
</script>
